// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/layout/header.scss
// module id = 582
// module chunks = 0